/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SocialExportCreateRudoFolderMutationRequest, SocialExportCreateRudoFolderMutationResponse, SocialExportCreateRudoFolderPathParams, SocialExportCreateRudoFolder400, SocialExportCreateRudoFolder401, SocialExportCreateRudoFolder403, SocialExportCreateRudoFolder404 } from "../models/SocialExportCreateRudoFolder";

export function getSocialExportCreateRudoFolderUrl(connectionId: SocialExportCreateRudoFolderPathParams["connectionId"]) {
  const res = { method: 'POST', url: `/social-export/v1/platforms/rudo/${connectionId}/folders` as const }
  return res
}

/**
 * @description Creates a folder on the connected Rudo account. Use the returned id as folderId when publishing or as the connection default.
 * @summary Create a Rudo folder for a connection
 * {@link /social-export/v1/platforms/rudo/:connectionId/folders}
 */
export async function socialExportCreateRudoFolder(connectionId: SocialExportCreateRudoFolderPathParams["connectionId"], data: SocialExportCreateRudoFolderMutationRequest, config: Partial<RequestConfig<SocialExportCreateRudoFolderMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<SocialExportCreateRudoFolderMutationResponse, ResponseErrorConfig<SocialExportCreateRudoFolder400 | SocialExportCreateRudoFolder401 | SocialExportCreateRudoFolder403 | SocialExportCreateRudoFolder404>, SocialExportCreateRudoFolderMutationRequest>({ method : "POST", url : getSocialExportCreateRudoFolderUrl(connectionId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}